import React from "react";

import MarketingLayout from "../components/templates/MarketingLayout";
import FeatureGrid from "../components/organisms/FeatureGrid";
import Hero from "../components/organisms/Hero";

export default function Home() {
  return (
    <MarketingLayout>
      <Hero />
      <FeatureGrid />
    </MarketingLayout>
  );
}
